<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-form ref="excelImportHsnp" v-model="excelImportHsnpValid">  
    <v-card-title>Import Night price excel file</v-card-title>
    
    <v-row no-gutters>
      <v-col class="ma-2">
         <v-file-input v-model="hsnp_file" id="myFile" ref="myFile"  @change="onFileChange" show-size label="Choose an excel file" filled prepend-icon="mdi-camera" accept=".xlsx" :rules="hsnp_fileRules"></v-file-input>
      </v-col>  
    </v-row>  
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small :disabled="!excelImportHsnpValid" @click="saveHsnp">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hspt_encrid: null,
      excelImportHsnpValid: false,
      url: null,
      src: null,
      hspt: {},
      hsnp_file: null,
      hsnp_fileRules: [
          v => !!v || "An excel file is required"
      ]
    }
  },
  methods: {
    open(hspt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hspt_encrid = hspt_encrid;
    },
    

     onFileChange() {
      var deze = this;
      
      const file = deze.hsnp_file;
      if (deze.hsnp_file != null) {
          deze.url = URL.createObjectURL(file);
      
          let reader = new FileReader();
      
          reader.readAsDataURL(file);
          reader.onload = evt => {
              this.src = evt.target.result;
            }

          reader.onerror = evt => {
             console.error(evt);
          }  
      } else  {
         deze.url = null;
      }   
    },
    saveHsnp() {
      this.excelImportHsnpValid = false;
      this.$axios
        .post("ares/json/ares/huis/hspt/hsnp/excelImportHsnp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelImportHsnp"
          },
          excelImportHsnp: {
            hspt_encrid: this.hspt_encrid,
            hsnp_file: this.src
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
             if (res.data.excelImportHsnp.color == "success") {
                this.$router.reload('/huis/hspt/hsnp/updHsnp/' + res.data.excelImportHsnp.hspt_encrid); 
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.excelImportHsnp.text,
              color: res.data.excelImportHsnp.color
            }); 
            this.dialog = false;
          }
        })
    },



  }
}
</script>

